define('shared/remote/efid/password/reset',[
    'Promise',
    '../domain',
    '../util',
    '$'
], function (
    Promise,
    getDomain,
    util,
    $
) {
    var URL_RESET = '/1/api/commerce-gateway/efid/user/password/email/reset/send';
    
    function reset(options) {
        return Promise.resolve()
            .then(function () {
                return util.getContinueURI({
                    defaultRedirect: true
                });
            })
            .then(function(uriContinue){
                var data = new URLSearchParams();
                data.append('identifier', options.email);
                data.append('type', 'email');
                data.append('continue_uri', uriContinue.toString());

                return $.ajax({
                        url:  URL_RESET,
                        method: 'POST',
                        dataType: 'json',
                        data: data.toString()
                    })
                    .promise()
                    .then(null, function(xhr){
                        var message = 'Fail to send password resetting email';
                        var errType = 'generic';
                        var fatal = true;
                        var json;
                        
                        if (xhr.status === 400) {
                            try {
                                json = JSON.parse(xhr.responseText);
                            } catch(ex) {
                                console.log('failed to parse json');
                            }

                            if (json && json.fields) {
                                message = '';
                                for (var key in json.fields) {
                                    var field = json.fields[key];
                                    message += field.text + '\n';
                                }
                            }

                            errType = 'format';
                            fatal = false;
                        } 

                        var err = new Error(message);
                        err.fatal = fatal;
                        err.type = errType;
                        return Promise.reject(err);
                    });
            });
    }   

    return reset;
});
